import builder from '../builder';
import Walking from '../../streamline-icons/light/walking.svg';

export default builder('IconWalkingLight', Walking);
